module.exports = __webpack_public_path__ + "static/img/zsLogo.233ed42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zsLogo.png
// module id = 2xk2
// module chunks = 1